import { render, staticRenderFns } from "./WebsiteExcelUploader.vue?vue&type=template&id=60850e24&"
import script from "./WebsiteExcelUploader.vue?vue&type=script&lang=js&"
export * from "./WebsiteExcelUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports